import { createTheme } from '@mui/material/styles';
import './ThemeTypes';

const DigibatCppTheme = createTheme(
    {
        palette: {
            common: {
                black: "#000000"
            },
            primary: {
                main: '#75f290',
                light: "#1d1c55",
                dark: "#bcbcc0"
            },
            secondary: {
                main: '#7b5fc7',
                light: "#a98fd8",
                dark: "#573f9a"
            },
            surface: {
                main: "#ffffffff",
            }
        }
    });

export default DigibatCppTheme;